<div class="Customers">
  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title" style="padding-bottom: 10px;">{{'customers.value_title' | translate}}</h1>
  </div>
  <div class="ui-g-12 ui-fluid">
    <p-steps [model]="types" [(activeIndex)]="activeIndex"  [readonly]="false"></p-steps>
  </div>

  <div class="ui-g-12 ui-fluid">
    <kv-search-toolbar
      [dateBoxEnabled]="true"
      [date_structure]="searchModel.date_structure"
      [card_modes]="searchModel.card_modes"
      [clusters]="searchModel.cluster_list"
      [customersBoxEnabled]="true"
      [clusterFieldEnabled]="true"
      [group_types]="searchModel.group_types"
      [selectedElapsedStart]="searchModel.selectedStartDate"
      [selectedElapsedEnd]="searchModel.selectedEndDate"
      [groups]="searchModel.groups"
      [areas]="searchModel.areas"
      [stores]="searchModel.stores"
      [disableMutualExclusivity]="false"
      [cardModeFieldEnabled]="false"
      appQFilter
      (onQFilter)="applyResult($event)" #toolbar
    ></kv-search-toolbar>
  </div>
  <div class="ui-g-12 ui-fluid">
    <app-customer-value-overview [hidden]="activeIndex !== 0" ></app-customer-value-overview>
    <app-customer-value-detail [hidden]="activeIndex !== 1" ></app-customer-value-detail>
    <app-customer-fair-share [hidden]="activeIndex !== 2" ></app-customer-fair-share>
    <app-customer-division-expense [hidden]="activeIndex !== 3" ></app-customer-division-expense>
    <app-customer-category-importance [hidden]="activeIndex !== 4" ></app-customer-category-importance>
    <app-customer-evolution [hidden]="activeIndex !== 5" ></app-customer-evolution>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value.component.html